import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './dropZone.module.css';

interface IBannerProps {
  onClick: () => void;
  onDrop: (e: any) => void;
}

interface IDropZoneProps {
  onChange: (files: FileList) => void;
  accept?: string[];
}

const Banner = ({ onClick, onDrop }: IBannerProps) => {
  const { t } = useTranslation();

  const handleDragOver = (ev: any) => {
    ev.preventDefault();
    ev.stopPropagation();
    ev.dataTransfer.dropEffect = 'copy';
  };

  const handleDrop = (ev: any) => {
    ev.preventDefault();
    ev.stopPropagation();
    onDrop(ev.dataTransfer.files);
  };

  return (
    <button
      type="button"
      className={styles.banner}
      onClick={onClick}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
    >
      <span className={styles.banner_text}>{t('pyClickToAdd')}</span>
      <span className={styles.banner_text}>{t('pyOr')}</span>
      <span className={styles.banner_text}>{t('pyDragAndDrop')}</span>
    </button>
  );
};

const DropZone = ({ onChange, accept = ['*'] }: IDropZoneProps) => {
  const inputRef = React.useRef<any>(null);

  const handleClick = () => {
    inputRef.current?.click();
  };

  const handleChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = ev.target;
    if (files) onChange(files);
  };

  const handleDrop = (files: FileList) => {
    onChange(files);
  };

  return (
    <div className={styles.wrapper}>
      <Banner onClick={handleClick} onDrop={handleDrop} />
      <input
        type="file"
        aria-label="add files"
        className={styles.input}
        ref={inputRef}
        onChange={handleChange}
        accept={accept.join(',')}
      />
    </div>
  );
};

export default DropZone;
